/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SubscriptionBilling from './subscription-billing';
import SubscriptionBillingDetail from './subscription-billing-detail';
import SubscriptionBillingUpdate from './subscription-billing-update';
import SubscriptionBillingDeleteDialog from './subscription-billing-delete-dialog';

const SubscriptionBillingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SubscriptionBilling />} />
    <Route path="new" element={<SubscriptionBillingUpdate />} />
    <Route path=":id">
      <Route index element={<SubscriptionBillingDetail />} />
      <Route path="edit" element={<SubscriptionBillingUpdate />} />
      <Route path="delete" element={<SubscriptionBillingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SubscriptionBillingRoutes;
